import { useState, useMemo, createContext } from 'react'
import { useQuery } from '@apollo/client'
import { GET_LOGGED_IN_USER } from '~/lib/get-logged-in-user'

export const LoggedInUserContext = createContext()

const LoggedInUserProvider = ({ children }) => {
  const [email, setEmail] = useState(null)
  const { data: queryData } = useQuery(GET_LOGGED_IN_USER)
  const { loggedInUser = null } = queryData || {}

  const value = useMemo(() => {
    return {
      loggedInUser,
      email,
      setEmail,
    }
  }, [loggedInUser, email])

  return <LoggedInUserContext.Provider value={value}>{children}</LoggedInUserContext.Provider>
}

export default LoggedInUserProvider
